/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  $('.SizeSwatch__Radio').each(function() {
    var $radio = $(this);
    var $div = $radio.closest('.HorizontalList__Item').find('div').first();

    if ($radio.val() === variant.title) {
      $div.css('z-index', '1'); // Set z-index to 1 or any desired value
    } else {
      $div.css('z-index', '-1'); // Reset z-index to -1 or any desired value
    }
  });
});

setTimeout(function(){
jQuery("#klaviyo-bis-iframe").on("load", function() {
  var head = jQuery("#klaviyo-bis-iframe").contents().find("head");
  var css = '<style>.btn{letter-spacing:0.1em;font-weight:400;font-size:14px;}h3.modal-title{font-size:14px;margin-bottom:30px;}.input-lg{background-color:#f2f2f2;border:0px;border-bottom:1px solid #413d38;height:36px; padding:10px 0;border-radius:0px;box-shadow:none}</style>';
  jQuery(head).append(css);
});
}, 700);

jQuery(document).ready(function() {
  if (navigator.userAgent.match(/bot|spider/i)) {

  }else{
      //fetch('https://reallyfreegeoip.org/json/')
        fetch('https://get.geojs.io/v1/ip/country.json') 
        .then(res => res.json())
          .then(data => {
              //var countryCode = data.country_code;
              var countryCode = data.country;
              var AUcountryList = ['AU','NZ'];
              var EUcountryList = ['AL','AD','AT','BY','BE','BA','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GI','GR','GG','VA','HU','IS','IE','IM','IT','JE','LV','LI','LT','LU','MK','MT','MD','MC','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SE','CH','UA','GB'];
              var ROWcountryList = ['AE','AF','AG','AI','AM','AO','AQ','AR','AS','AW','AX','AZ','BB','BD','BF','BH','BI','BJ','BL','BM','BN','BO','BQ','BR','BS','BT','BV','BW','BZ','CA','CC','CD','CF','CG','CI','CK','CL','CM','CN','CO','CR','CU','CV','CW','CX','DJ','DM','DO','DZ','EC','EG','EH','ER','ET','FJ','FK',"FM","FO",'GA','GD','GE','GF','GH','GL','GN','GP','GQ','GS','GT','GU','GW','GY','HK','HM','HN','HR','HT','ID','IL','IN','IO','IQ','IR','JM','JO','JP','KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ','LA','LB','LC','LK','LR','LS','LY','MA','MF','MG','MH','ML','MM','MN','MO','MP','MQ','MR','MS','MU','MV','MW','MX','MY','MZ','NA','NC','NE','NI','NF','NG','NR','NP','NU','OM','PA','PE','PF','PG','PH','PK','PM','PN','PR','PS','PW','PY','QA','RE','RW','SA','SB','SC','SD','SG','SH','SJ','SL','SN','SO','SR','SS','ST','SV','SX','SY','TC','TD','TF','TG','TH','TJ','TK','TL','TM','TN','TO','TT','TV','TW','TZ','UA','UG','UM','US','UZ','UY','VC','VE','VG','VI','VN','VU','WF','WS','YE','YT','ZM','ZW','ZA'];
        
              /*if (jQuery.inArray(countryCode, ROWcountryList) >= 0) {
                $('.template-product #location-redirect-message-product .redirect-me').attr('href','https://rhythmlivin.com'+window.location.pathname);
              }else if(jQuery.inArray(countryCode, EUcountryList) >= 0) {
                jQuery('.template-product #location-redirect-message-product .redirect-me').attr('href','https://eu.rhythmlivin.com'+window.location.pathname);
              }else{
                jQuery('.template-product #location-redirect-message-product').hide();
              }
          */
          var host = window.location.hostname;
          var path = window.location.pathname;
      
          // Figure out visitor's recommended region
          var targetRegion = null;
          if (jQuery.inArray(countryCode, AUcountryList) >= 0) {
            targetRegion = 'AU';
          } else if (jQuery.inArray(countryCode, EUcountryList) >= 0) {
            targetRegion = 'EU';
          } else if (jQuery.inArray(countryCode, ROWcountryList) >= 0) {
            targetRegion = 'ROW';
          }
      
          // What region is the current domain?
          var currentRegion = 'ROW';
          if (host.indexOf('au.rhythmlivin.com') === 0) {
            currentRegion = 'AU';
          } else if (host.indexOf('eu.rhythmlivin.com') === 0) {
            currentRegion = 'EU';
          }
      
          // Only show message if user is NOT on their intended region
          if (targetRegion && targetRegion !== currentRegion) {
            var redirectUrl = '';
            if (targetRegion === 'AU') {
              redirectUrl = 'https://au.rhythmlivin.com' + path;
            } else if (targetRegion === 'EU') {
              redirectUrl = 'https://eu.rhythmlivin.com' + path;
            } else {
              redirectUrl = 'https://rhythmlivin.com' + path;
            }
            $('.template-product #location-redirect-message-product .redirect-me').attr('href', redirectUrl);
            $('.template-product #location-redirect-message-product').show();
          } else {
            // On correct region, hide the message
            $('.template-product #location-redirect-message-product').hide();
          }
        })
        .catch(function (e) {
          // In case of GeoIP failure, hide
          $('.template-product #location-redirect-message-product').hide();
        });  
  }
});

function yotpoChanges(){
  var status = $('.yotpo-vip-tiers-progress-bar-summary-current .yotpo-templated-variable').text();
  console.log('status',status);
  if(status == 'Casual'){
    $('.yotpo-progress-bar-top-left').text('Casual');
    $('.yotpo-progress-bar-top-right').addClass('casual');
  }else if(status == 'Connected'){
    $('.yotpo-progress-bar-top-left').text('Connected');
    $('.yotpo-progress-bar-top-left').addClass('connected');
    $('.yotpo-vip-tiers-progress-bar-summary-current').html("<span style='color: rgb(66, 61, 55); font-size: 14px; font-family: Montserrat; font-weight: 500;'>You're <span class='yotpo-templated-variable'>Connected</span>. A familiar face.</span>");
    var points = $('.yotpo-vip-tiers-progress-bar-summary-next .yotpo-templated-variable').text();
    $('.yotpo-vip-tiers-progress-bar-summary-next').html('<div class="yotpo-vip-tiers-progress-bar-summary-next"><span style="color: rgb(66, 61, 55); font-size: 14px; font-family: Montserrat; font-weight: 500;">Only <span class="yotpo-templated-variable">'+ points +'</span> more points needed to join the inner circle.</span></div>');
  }else if(status == 'Insider'){
    $('.yotpo-progress-bar-top-left').text('Casual');
    $('.yotpo-vip-tiers-progress-bar-summary-current').html("<span style='color: rgb(66, 61, 55); font-size: 14px; font-family: Montserrat; font-weight: 500;'>You're an <span class='yotpo-templated-variable'>Insider</span>. You're in!</span>");
/*    $('.yotpo-vip-tiers-progress-bar-summary').append('<div class="yotpo-vip-tiers-progress-bar-summary-final"><span style="color: rgb(66, 61, 55); font-size: 14px; font-family: Montserrat; font-weight: 500;">Maintain your benefits and access to content by earning <span class="yotpo-templated-variable">'+ points +'</span> points.</span></div>');*/
  }
}

var timer = setInterval(function() {
  var yotpoLength = $('.yotpo-vip-tiers-progress-bar-summary-current').length;
  if (yotpoLength > 0){
    yotpoChanges();
    clearInterval(timer);
  } 
}, 200);

function drawCross(element){
  var c = element
  var ctx = c.getContext("2d");
  ctx.beginPath();
  ctx.lineWidth = 5;
  ctx.lineCap = 'round';
  ctx.strokeStyle = "#777";
  ctx.moveTo(0,0);
  ctx.lineTo(c.width, c.height);
  ctx.stroke();
  ctx.moveTo(c.width,0);
  ctx.lineTo(0,c.height);
  ctx.stroke();
}  
class LoadMore extends HTMLElement {
 constructor() {
  super();
  this.addEventListener("click", this.loadMoreItems);
 }

loadMoreItems() { 
 const loadMoreBtn = this.querySelector('[type="button"]');
 loadMoreBtn.setAttribute("disabled", true);
 loadMoreBtn.textContent = 'Loading...';
 let { currentPage, pageSize, nextUrl, totalItems } = this.dataset
 let nextPage = parseInt(this.dataset.currentPage) + 1
fetch(nextUrl.replace(/page=[0-9]+/, 'page=' + nextPage))
 .then(response => response.text())
 .then((responseText) => {
  const html = responseText;
  $('.ProductList')
   .append($(html)
   .find('.ProductList')
   .html());
  })
 .catch((e) => {
     console.error(e);
  })
 .finally(() => {
  loadMoreBtn.removeAttribute("disabled");
  loadMoreBtn.textContent = 'Load More';
  this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
  let isLastPage = parseInt(totalItems) - (nextPage * parseInt(pageSize)) < 0
  // this.querySelector('[load-items-count]').innerHTML = isLastPage ? parseInt(totalItems) : nextPage * parseInt(pageSize)
  if(isLastPage){
    loadMoreBtn.classList.add('hide');
  }
  $('.item-cross').each(function() {
    drawCross(this)
  });
 });
 }
}
customElements.define('load-more', LoadMore);


$( window ).on("resize", function() {
  $('.Slideshow__Carousel').each(function() {
    var divHeight = $(this).find('.Slideshow__Slide').height();
    console.log('height',$(this).find('.Slideshow__Slide'));
    $(this).find('.flickity-viewport').css("height",divHeight+"px");
  });

  $('.ProductList--carousel').each(function() {
    var divHeight = $(this).find('.Carousel__Cell').height();
    console.log('height',$(this).find('.Carousel__Cell'));
    $(this).find('.flickity-viewport').css("height",divHeight+"px");
  });
});